module.exports = __webpack_public_path__ + "img/scotland-logo-icon.735f217e.png";